import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a59c8d5c")

_pushScopeId("data-v-a59c8d5c")
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Início")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Buscar")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Pedidos")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Perfil")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")
  const _component_ion_tabs = _resolveComponent("ion-tabs")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_tabs, null, {
        default: _withId(() => [
          _createVNode("section", _hoisted_1, [
            _createVNode("div", {
              class: "tab-logo",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.goTo('/tabs/explore')))
            }, [
              _createVNode(_component_ion_icon, {
                class: "icon-logo",
                src: "/THELIVERY_LOGO.svg"
              })
            ]),
            _createVNode(_component_ion_tab_bar, { slot: "bottom" }, {
              default: _withId(() => [
                _createVNode(_component_ion_tab_button, {
                  tab: "inicio",
                  href: "/tabs/inicio"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.homeOutline }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  tab: "search",
                  href: "/tabs/search"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.search }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  class: "tab-center",
                  tab: "promotions"
                }),
                _createVNode(_component_ion_tab_button, {
                  tab: "Orders",
                  href: "/tabs/Orders"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.list }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  tab: "perfil",
                  href: "/tabs/perfil"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.personOutline }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})